import React from 'react'
import { Icon } from '@blueprintjs/core'
import { IconNames } from '@blueprintjs/icons'

const ItemDetails = ({ children }) => (
  <div className="item-details">
    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
      <div className="drawer-header">
        <Icon icon={IconNames.TAG} /> Listing Details
      </div>
    </div>

    <div className="details">{children}</div>
  </div>
)
export default ItemDetails
